$( "#extra_fields" ).on( "click", ".remove_field", function( event ) {
  event.preventDefault();
  $(this).parent().parent().remove();
});
